import portalAxiosInstance from './portalAxiosInstance';

const PortalContractService = {
    getContracts: () =>
        portalAxiosInstance.get('/api/portal/contracts').then(r => r.data),

    getContract: (id) =>
        portalAxiosInstance.get(`/api/portal/contracts/${id}`).then(r => r.data),

    requestChanges: (id, comment) =>
        portalAxiosInstance
            .post(`/api/portal/contracts/${id}/request-changes`, { comment })
            .then(r => r.data),

    downloadPdf: (id) =>
        portalAxiosInstance.get(`/api/portal/contracts/${id}/pdf`, { responseType: 'blob' }),

    getNotes: (id) =>
        portalAxiosInstance.get(`/api/portal/contracts/${id}/notes`).then(r => r.data),

    addNote: (id, content) =>
        portalAxiosInstance.post(`/api/portal/contracts/${id}/notes`, { content }).then(r => r.data),

    editNote: (id, noteId, content) =>
        portalAxiosInstance.put(`/api/portal/contracts/${id}/notes/${noteId}`, { content }).then(r => r.data),

    deleteNote: (id, noteId) =>
        portalAxiosInstance.delete(`/api/portal/contracts/${id}/notes/${noteId}`).then(r => r.data),
};

export default PortalContractService;
